import TextFieldController from '../FormControllerComponents/TextFieldController'
import { maskCNPJCPF } from 'utils/formataValidaDocumentos'
import { IField } from '.'
import { Control, FieldErrors, FieldValues } from 'react-hook-form'
import { Box } from 'components/Material/index'
import { DateInputController } from '../FormControllerComponents/DateInputController'
import { SelectInputController } from '../FormControllerComponents/SelectInputController'
import { getErrorMessage } from './utils'
import NumberInputController from '../FormControllerComponents/NumberInputController'

interface FormConstrutorInputsProps<T extends FieldValues> {
  field: IField<T>
  control: Control<T>
  errors: FieldErrors<T>
}

export const FormConstrutorInputs = <T extends FieldValues>({
  field,
  control,
  errors
}: FormConstrutorInputsProps<T>) => {
  switch (field.type) {
    case 'text':
      return (
        <TextFieldController
          name={field.name}
          control={control}
          label={field.label}
          maxLength={field.maxLength}
          errorMessage={getErrorMessage(field.name, errors)}
        />
      )
    case 'number':
      return (
        <NumberInputController
          control={control}
          name={field.name}
          label={field.label}
          maxLength={field.maxLength}
          min={field.minLength}
          type="integer"
          errorMessage={getErrorMessage(field.name, errors)}
        />
      )

    case 'document':
      return (
        <TextFieldController
          name={field.name}
          control={control}
          label={field.label}
          maxLength={field.maxLength}
          errorMessage={getErrorMessage(field.name, errors)}
          mask={maskCNPJCPF}
        />
      )

    case 'date':
      if (!field.doubleField) return null // Garantir retorno explícito de null
      return (
        <Box className="flex flex-col">
          <Box className="flex gap-[10px]">
            <DateInputController
              control={control}
              name={field.doubleField.nameInicial}
              label={field.doubleField.labelInicial}
              errorMessage={getErrorMessage(field.doubleField.nameInicial, errors)}
            />
            <DateInputController
              control={control}
              name={field.doubleField.nameFinal}
              label={field.doubleField.labelFinal}
              errorMessage={getErrorMessage(field.doubleField.nameFinal, errors)}
            />
          </Box>
          {/* //TODO: Validar se é necessário manter o FormHelperText */}
          {/* <Box className="w-full flex justify-end px-2">
            <FormHelperText className="w-fit" error>
              {getErrorMessage(field.doubleField.nameFinal, errors)}
            </FormHelperText>
          </Box> */}
        </Box>
      )

    case 'select':
      return (
        <SelectInputController
          control={control}
          name={field.name}
          label={field.label}
          menuItems={field.options ?? []}
          errors={getErrorMessage(field.name, errors)}
          className="w-full"
        />
      )

    case 'doubleNumber':
      if (!field.doubleField) return null // Garantir retorno explícito de null
      return (
        <Box className="flex gap-[10px]">
          <NumberInputController
            control={control}
            name={field.doubleField.nameInicial}
            label={field.doubleField.labelInicial}
            type="integer"
            maxLength={10}
            errorMessage={getErrorMessage(field.doubleField.nameInicial, errors)}
          />
          <NumberInputController
            control={control}
            name={field.doubleField.nameFinal}
            label={field.doubleField.labelFinal}
            type="integer"
            errorMessage={getErrorMessage(field.doubleField.nameFinal, errors)}
            maxLength={10}
          />
        </Box>
      )

    default:
      return null // Retorno explícito de null para o caso padrão
  }
}
